module.exports = __webpack_public_path__ + "media/components/page-payment/line-icon-ceeb99c334f89e2ade5932b0c82210c7.svg";